/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectionIndices } from '../../models/collection-indices';

export interface ServerStatusControllerGetCollectionIndices$Params {
}

export function serverStatusControllerGetCollectionIndices(http: HttpClient, rootUrl: string, params?: ServerStatusControllerGetCollectionIndices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollectionIndices>>> {
  const rb = new RequestBuilder(rootUrl, serverStatusControllerGetCollectionIndices.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CollectionIndices>>;
    })
  );
}

serverStatusControllerGetCollectionIndices.PATH = '/server-status/collectionIndices';
